"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var LoadingSpinner_1 = __importDefault(require("atomicComponents/atoms/Icons/LoadingSpinner"));
var FadeoutBottom_1 = __importDefault(require("atomicComponents/atoms/Scroll/FadeoutBottom"));
var SelectButtonGrid_1 = __importDefault(require("atomicComponents/organisms/Button/SelectButtonGrid"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
// import { selectRechargedCompanyVendors, selectRechargedVendors } from 'utils/selectors/ordered';
var ordered_1 = require("utils/selectors/ordered");
var single_1 = require("utils/selectors/single");
var SelectEmailProvider_1 = __importDefault(require("../ModalComponents/SelectEmailProvider"));
// import ImportChargesByUrl from './ImportChargesByUrl';
var VendorEmailContent_1 = __importDefault(require("../ModalComponents/VendorEmailContent"));
var UploadLatestInvoice_1 = __importDefault(require("./UploadLatestInvoice"));
var AddVendorModalContent = function (_a) {
    var _b;
    var searchText = _a.searchText, handleSelectVendor = _a.handleSelectVendor, setEmailProvider = _a.setEmailProvider, emailProvider = _a.emailProvider, selectedVendor = _a.selectedVendor, firstMailStepDone = _a.firstMailStepDone, set1stMailStepDone = _a.set1stMailStepDone;
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var rechVendors = (0, react_redux_1.useSelector)(ordered_1.selectNewRechargedVendors);
    var options = rechVendors === null || rechVendors === void 0 ? void 0 : rechVendors.map(function (rV) { return ({ label: rV.name, value: rV.name, logo: rV.logoUrl }); });
    var rechCompanyVendors = (0, react_redux_1.useSelector)(ordered_1.selectRechargedCompanyVendors);
    var searchedRechVendors = react_1.default.useMemo(function () { return options === null || options === void 0 ? void 0 : options.filter(function (rV) { return rV.label.toLowerCase().includes(searchText.toLowerCase()); }); }, [searchText]);
    var handleSelectProvider = function (provider) { return setEmailProvider(provider); };
    var handleOnClick = function (vendor) { return handleSelectVendor(vendor); };
    if (!rechVendors) {
        return (0, jsx_runtime_1.jsx)(LoadingSpinner_1.default, {});
    }
    if (!selectedVendor) {
        return !(searchedRechVendors === null || searchedRechVendors === void 0 ? void 0 : searchedRechVendors.length)
            ? (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3, textAlign: "center", py: 4 }, { children: "No vendors found" }))
            : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, __assign({ pb: 4 }, { children: (0, jsx_runtime_1.jsx)(SelectButtonGrid_1.default, { options: searchedRechVendors, handleClick: handleOnClick, disabled: !!(rechCompanyVendors === null || rechCompanyVendors === void 0 ? void 0 : rechCompanyVendors.find(function (vendor) { return vendor.rechVendorId === selectedVendor; })) }) })), (0, jsx_runtime_1.jsx)(FadeoutBottom_1.default, { height: searchedRechVendors.length > 5 ? 64 : 0, width: "94%" })] }));
    }
    if ((selectedVendor === null || selectedVendor === void 0 ? void 0 : selectedVendor.mainImportMethod) !== 'email') {
        return (0, jsx_runtime_1.jsx)(UploadLatestInvoice_1.default, { selectedVendor: selectedVendor });
    }
    if (!firstMailStepDone) {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(VendorEmailContent_1.default, { vendor: selectedVendor.name, companyName: (_b = company === null || company === void 0 ? void 0 : company.name) !== null && _b !== void 0 ? _b : 'COMPANY_NAME' }), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: function () { return set1stMailStepDone(true); } }, { children: "Done" }))] }));
    }
    return (0, jsx_runtime_1.jsx)(SelectEmailProvider_1.default, { emailProvider: emailProvider, handleSelect: handleSelectProvider, vendor: selectedVendor.name });
};
exports.default = AddVendorModalContent;
